import { START_LOADING, GET_USER_DATA, GET_MONTH_PLANS, STOP_LOADING, GET_MONTH_PLANS_PDF, ERROR, GET_MONTH_PLANS_SHEET } from "../monthPlanAction/types";


const INITIAL_STATE = {
  loading: false,
  success: false
}

export default function (state = INITIAL_STATE, action) {

  switch (action.type) {
    case GET_MONTH_PLANS:
      return {
        ...state,
        month_plans: action.payload,
        success: false,
        loading: false
      }
    case GET_USER_DATA:
      return {
        ...state,
        user_data: action.payload,
        success: false,
        loading: false
      }
    case GET_MONTH_PLANS_PDF:
      return {
        ...state,
        month_plan_pdf: action.payload,
        success: false,
        loading: false
      }
    case GET_MONTH_PLANS_SHEET:
      return {
        ...state,
        month_plan_sheet: action.payload,
        success: false,
        loading: false
      }
    case START_LOADING:
      return {
        ...state,
        loading: true
      }
    case STOP_LOADING:
      return {
        ...state,
        loading: false
      }
    case ERROR:
      return {
        ...state,
        error_message: action.payload,
        loading: false
      }
    default:
      return {
        ...state
      }
  }
}